<powerbi-report title="powerbi" #reportEmbedModal [cssClassName]="'report-container-page'" [embedConfig]="embedConfig"
    [phasedEmbedding]="false" [eventHandlers]="eventHandlersMap">
</powerbi-report>